import React from 'react';
import RebootNotification from './RebootNotification.js';
const RebootEPINotification = ({ boxDetails, obiReboot }) => {
  return (
    <div className="reboot-notification-container">
      {boxDetails?.Obis &&
        boxDetails.Obis.map(item => {
          return item.rebootRequired ? (
            <RebootNotification macAddress={item.macAddress} deviceId={item.deviceId} onReboot={obiReboot} />
          ) : null;
        })}
    </div>
  );
};

export default RebootEPINotification;
